import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);

dayjs.extend(timezone);

export function formatRecordingDisplayName(
  filename: string,
  timeZone: string
): string {
  try {
    const base = filename.replace(/\.[^/.]+$/, "");
    const parts = base.split("_");

    if (parts.length < 3) return filename;

    const durationStr = parts.pop() as string;
    const startTimeRaw = parts.pop() as string; // HH-mm-ss
    const dateRaw = parts.pop() as string; // YYYY-MM-DD

    // Filename timestamps are UTC; convert to the provided timeZone for display
    const start = dayjs
      .utc(`${dateRaw} ${startTimeRaw.replace(/-/g, ":")}`)
      .tz(timeZone);

    if (!start.isValid()) {
      return filename;
    }

    const durationMin = parseInt(durationStr, 10);
    const end = start.add(isNaN(durationMin) ? 0 : durationMin, "minute");

    const dayMonth = start.format("D MMMM");
    const range = `${start.format("h:mma")} - ${end.format("h:mma")}`;

    return `${dayMonth}, ${range}`;
  } catch {
    return filename;
  }
}
